import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  class: "wrapper-container"
};
const _hoisted_3 = {
  class: "wrapper-container-menu"
};
const _hoisted_4 = {
  class: "wrapper-container-main"
};
import BreadCrumb from '@/components/BreadCrumb.vue';
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
export default {
  __name: 'Index',
  setup(__props) {
    const headerMenus = useRouter().options.routes.find(i => i.name === 'main').children;
    const advertMenus = headerMenus.find(i => i.name === 'advert').children;
    const activeIndex = ref(null);
    onMounted(() => {
      activeIndex.value = useRouter().currentRoute.value.path;
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_router_view = _resolveComponent("router-view");
      const _directive_has = _resolveDirective("has");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(BreadCrumb), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        router: true,
        "background-color": "#fefefe",
        "text-color": "#545454",
        "active-text-color": "#4696F8"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advertMenus), item => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            key: item.name,
            index: item.path
          }, {
            title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["index"])), [[_directive_has, item.meta.permission]]);
        }), 128))]),
        _: 1
      }, 8, ["default-active"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_view)])])]);
    };
  }
};